{
  "ERROR_HEADER": "Something went wrong while loading the PDF.",
  "ERROR_MESSAGE": "Please update your browser to the latest version and try again. If you're still experiencing issues, please submit a CR for additional assistance."
}
